import { FC, PropsWithChildren } from 'react';
import { RPDF } from '../../react-pdf';
import { ReportColors } from '../../report-colors';

export const FieldGroup: FC<
  PropsWithChildren<{
    title: string;
    hideTitle?: boolean;
  }>
> = ({ children, title, hideTitle }) => {
  return (
    <RPDF.View style={{ marginTop: 8, marginBottom: 8, flexShrink: 0 }}>
      {!hideTitle && (
        <RPDF.Text
          wrap={false}
          minPresenceAhead={40}
          style={{
            ...RPDF.typography.heading5b,
            ...RPDF.tableStyles.divider,
            paddingTop: 4,
            paddingBottom: 4,
            borderBottomColor: ReportColors.main300,
            flexShrink: 0,
          }}
        >
          {title}
        </RPDF.Text>
      )}
      <RPDF.View style={{ minHeight: 32 }}>{children}</RPDF.View>
    </RPDF.View>
  );
};
